import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandDeactivationCreateDto,
  StandDeactivationUpdateDto,
} from '../proxy/geographic/dtos/stand-deactivation';
import { STANDDEACTIVATION_CONFIG, STANDDEACTIVATION_FIELDS } from './stand-deactivation.config';
import { BaseCrudComponent, CrudPage, GenericForm, ICrudService } from '@zendra/shared';
import { StandDeactivationService } from '../proxy/geographic/controllers';
import { StandDeactivationProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  GetStandDeactivationProjectionListInputDto,
  StandDeactivationProjectionDto,
  StandDeactivationProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/stand-deactivations/models';

@Component({
  selector: 'app-stand-deactivation',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandDeactivationService, ConfirmationService],
  templateUrl: './stand-deactivation.html',
  styleUrl: './stand-deactivation.scss',
})
export class StandDeactivation extends BaseCrudComponent<
  StandDeactivationProjectionDto,
  StandDeactivationCreateDto,
  StandDeactivationUpdateDto,
  StandDeactivationProjectionExcelDownloadDto
> {
  private readonly geographicService = inject(StandDeactivationService);
  private readonly orchestratorService = inject(StandDeactivationProjectionPlanningOrchestratorService);

  service: ICrudService<
    StandDeactivationProjectionDto,
    StandDeactivationCreateDto,
    StandDeactivationUpdateDto,
    StandDeactivationProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    getList: (query: GetStandDeactivationProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'standDeactivationId',
    ),
  };
  config = STANDDEACTIVATION_CONFIG;
  fields = STANDDEACTIVATION_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: StandDeactivationProjectionDto,
  ): StandDeactivationUpdateDto {
    return {
      isActive: data.isActive,
      standLocationId: data.standLocationId,
      deactivationReasonId: data.deactivationReasonId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandDeactivation';
  }
}
